import React, { useState, useContext} from 'react';
//import 'bulma/css/bulma.min.css';
import '../view-archer-styles.css';

// material-ui: theme, colors, icons
import { Avatar, Alert, Card, CardContent, Grid, Stack, Typography, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material/';
import { Drafts, PageviewOutlined } from '@mui/icons-material/';

//components import
import DashboardPreviewDraftLetter from './DashboardPreviewDraftLetter';
import ArcherLetter from '../dataObjects/ArcherLetter';
import { AuditorCommunicationContext } from '../view-archer';

interface Props {
    draftLetters?: ArcherLetter[];
}

const DashboardDraftLeters = (props: Props) => {

    const [isPreviewDialogOpen, setPreviewDialogOpen] = useState(false);
    const [currentLetterId, setCurrentLetterId] = useState(0);

    const previewLetter = (letterId: number) => {
        setCurrentLetterId(letterId);
        setPreviewDialogOpen(true);
    }

    const context = useContext(AuditorCommunicationContext);

    const setCurrentLetterCpfId = (cpfId: number) => {
        context.setCurrentLetterCpfId(cpfId);
    }

    const setCurrentCpfIdAndLetterId = (cpfId: number, letterId: number) => {
        context.setCurrentLetterCpfId(cpfId);
        context.setCurrentLetterId(letterId);
    }

    return (
        <div>
            <Card className="dashboard-tile">
                <CardContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Grid container alignContent="center" justifyContent="space-between">
                                <Grid item>
                                    <Typography variant="subtitle1" color="blue">Draft Letters {props.draftLetters && `(${props.draftLetters.length})`}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            {
                                props.draftLetters && props.draftLetters.length === 0 &&
                                <Alert severity="success" sx={{ margin: 2 }}>There are no draft Archer letters!</Alert>
                            }
                            {
                                props.draftLetters && props.draftLetters.length > 0 &&
                                <TableContainer sx={{ maxHeight: 265 }}>
                                    <Table sx={{ minWidth: 650 }} size="small" aria-label="draft letter table">
                                        <TableBody>
                                            {
                                                props.draftLetters?.map((letter) =>
                                                    <TableRow key={letter.id} >
                                                        <TableCell>
                                                            <Avatar sx={{ bgcolor: '#ffc107' }} className="small-avatar"><Drafts fontSize="small" /></Avatar>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Stack spacing={2}>
                                                                <Typography variant="body2"  className="is-clickable" onClick={() => setCurrentLetterCpfId(letter.cpfId)}><b>{letter.cpfId} {letter.filerFullNameReverse}</b></Typography>
                                                                <Typography className="issue-link-text is-clickable" color="blue" onClick={() => setCurrentCpfIdAndLetterId(letter.cpfId, letter.id)}  ><i>{letter.letterTemplateCode} {letter.date}</i></Typography>
                                                            </Stack>
                                                        </TableCell>
                                                        <TableCell align="right" width="50%">
                                                            <Stack spacing={2}>
                                                                {
                                                                    letter.issueListings &&
                                                                    letter.issueListings.map((issue) =>
                                                                        <span key={issue.issueId}><span className="Delinquent">{issue.issueTypeCode} {issue.header}</span></span>)
                                                                }
                                                            </Stack>
                                                        </TableCell>
                                                        <TableCell>
                                                            <PageviewOutlined className="is-clickable" color="success" onClick={() => previewLetter(letter.id)} />
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            }
                            
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            <DashboardPreviewDraftLetter isPreviewDialogOpen={isPreviewDialogOpen} letterId={currentLetterId} closePreviewDialog={() => setPreviewDialogOpen(false)} />
        </div>
    )
}

export default DashboardDraftLeters;